<template>
  <div class="face-pills-wrapper-large flex self-center items-center" :class="colorClass">
      <div class="face-icon-wrapper">
        <img :src="faceIcon">   
    </div>
    <div class="border"></div>
    <div class="text-wrapper flex flex-col flex-grow items-center">
        <div class="value text-shadow-strong">{{value}}</div>
        <div class="text text-shadow-strong">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['type'],
    data() {
        return {
            faceIcon: null,
            colorClass: null,
            text: null,
            value: null
        }
    },
    watch: {
        type(n,o) {
            if(n && n != o)
                this.setValues();
        }
    },
    created() {
        this.setValues()
    },
    methods: {
        setValues() {
            switch (this.type) {
                case 1:
                    this.faceIcon = require('@/assets/images/smiley-faces/good.svg');
                    this.text = 'Good';
                    this.value = "1";
                    this.colorClass = 'bg-aqi-blue';
                    break;
                case 2:
                    this.faceIcon = require('@/assets/images/smiley-faces/moderate.svg');
                    this.text = 'Moderate';
                    this.value = "2";
                    this.colorClass = 'bg-aqi-yellow';
                    break;
                case 3:
                    this.faceIcon = require('@/assets/images/smiley-faces/inadequate.svg');
                    this.text = 'Inadequate';
                    this.value = "3";
                    this.colorClass = 'bg-aqi-orange';
                    break;
                case 4:
                    this.faceIcon = require('@/assets/images/smiley-faces/bad.svg');
                    this.text = 'Bad';
                    this.value = "4";
                    this.colorClass = 'bg-aqi-red';
                    break;
                case 5:
                    this.faceIcon = require('@/assets/images/smiley-faces/very-bad.svg');
                    this.text = 'Very Bad';
                    this.value = "5";
                    this.colorClass = 'bg-aqi-purple';
                    break;
            
                default:
                    break;
            }
        }
    }

}
</script>

<style lang="scss">
.face-pills-wrapper-large{
    border-radius: 100px;
    //padding: 10px;
    min-width: 400px;
    position: relative;
 .face-icon-wrapper {
    width: 100px;
    margin-left: 14px;
    img {
        filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .2));
    }
    //margin-left: 5px;
 }
 .border {
     border-right: 2px solid white;
     height: 66px;
     margin: 0 0px 0 20px;
     position: absolute;
     left: 120px;
 }
 .text-wrapper {
     .value{
         font-size: 5rem;
         line-height: 1.1em;
     }
     .text {
         color: white;
         font-size: 1.5rem;
     }
 }
    &.bg-aqi-yellow {
        .text, .value {
            color: #444444;
            text-shadow: none;
        }
    }
}

 //lg
@media (max-width: 1279.98px) { 

}

//md
@media (max-width: 1023.98px) {

}

// sm
@media (max-width: 767.98px) { 
    .face-pills-wrapper-large{
        min-width: 300px;
    .face-icon-wrapper {
        width: 80px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .border {
        border-right: 2px solid white;
        height: 66px;
        margin: 0 0px 0 20px;
        position: absolute;
        left: 90px;
    }
    .text-wrapper{
        .value {
            font-size: 3rem;
        }
    }
}
}

// xs
@media (max-width: 639.98px) { 

}
</style>